import Vue from 'vue'
import Router from 'vue-router'
import Intro from '@/domains/Intro'
import ChoiceOM from '@/domains/ChoiceOM'
import Overheid from '@/domains/Overheid'
import Museum from '@/domains/Museum'
import ChoiceEB from '@/domains/ChoiceEB'

Vue.use(Router)

export default new Router({
  base: '/vervreemdingsprocedure/',
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'Intro',
      component: Intro
    },
    {
      path: '/overheidsorganisatie-of-museum',
      name: 'Overheidsorganisatie of museum',
      component: ChoiceOM
    },
    {
      path: '/overheid',
      name: 'Overheid',
      component: Overheid,
      children: [
        {
          path: '*',
          component: Overheid
        }
      ]
    },
    {
      path: '/museum',
      name: 'ChoiceEB',
      component: ChoiceEB
    }, {
      path: '/museum/:id',
      name: 'Museum',
      component: Museum
    }, {
      path: '*',
      redirect: '/'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js